import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { SampleOrderContent } from '../../components/SampleOrderContent/SampleOrderContent';

export const SampleOrderSuspenseFallback = () => (
  <div className="flex h-full w-full overflow-hidden">
    <div className="flex w-full flex-row overflow-hidden">
      <div className="flex h-full shrink grow basis-0 flex-col">
        <div className="bg-color-background-base">
          <div className="flex flex-col items-center gap-1.5">
            <div className="flex w-full flex-row flex-nowrap items-center gap-2">
              <Skeleton className="size-2 shrink-0 grow-0 rounded-full" />
              <Skeleton className="size-0.5 w-full" />
              <Skeleton className="size-2 shrink-0 grow-0 rounded-full" />
              <Skeleton className="size-0.5 w-full" />
              <Skeleton className="size-2 shrink-0 grow-0 rounded-full" />
            </div>
            <Skeleton className="mb-4 h-2 w-1/2" />
          </div>
        </div>
        <div className="h-full shrink grow basis-0">
          <SampleOrderContent
            pageContent={
              <div className="flex flex-col gap-2">
                <Skeleton className="h-[160px] w-full" />
                <Skeleton className="h-[160px] w-full" />
                <Skeleton className="h-[160px] w-full" />
              </div>
            }
            actionBarContent={
              <div className="flex w-full flex-row items-center justify-end gap-1 p-2">
                <Skeleton className="h-2 w-2/5" />
                <Skeleton className="h-3 w-2/5" />
              </div>
            }
          />
        </div>
      </div>
    </div>
  </div>
);
